import React, { Fragment, useState } from "react";
// import {Form, Form.Item} from "reactstrap";
import imgEyeClosed from "assets/images/login/security-uncheck.svg";
import imgEyeOpen from "assets/images/login/security-check.svg";
import { ValidateResetPassInput } from "./validateChangePassword";
import {
  getErrorObject,
  errorToast,
  successToast,
  verifyObject,
} from "../../utilities/utils";
import { ResetPasswordWithTokenApi } from "../../services/session";
import { Form, Button } from "antd";
import LoginCSS from "./Login.module.scss";
import LoginHeader from "components/Login/LoginHeader";
import LoginFooter from "components/Login/LoginFooter";
// import { Navigate } from "react-router-dom";
// import { appRoutesConst } from "app/navigation";
// import {navigateTo} from "app/navigation";
import { useNavigate } from "react-router";
import FloatLabel from "components/common/FloatLabel";

const ResetPasswordWithToken = (props) => {
  const [passwordVisible, setPasswordVisibe] = useState(false);
  const [confirmpasswordVisible, setConfirmPasswordVisible] = useState(false);
  // const[oldpasswordVisible,set]=useState(false);
  // existing_password=useState("");
  const [password, setPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState(null);

  // const [state, setState] = useState(initialState);
  const navigate = useNavigate();

  // const handleChange = (e) => {
  //   let errors = null;
  //   let name = e.target.name;
  //   let value = e.target.value;
  //   if (state.errors) {
  //     errors = Object.assign("", state.errors);
  //     delete errors[e.target.name];
  //   }
  //   setState({...state, [e.target.name]: e.target.value, errors: errors});
  //   //  () => {
  //   //   if (state[name] !== "") {
  //   //     let data = {
  //   //       [name]: value,
  //   //     };
  //   //     const errors = ValidateResetPassInput(data);
  //   //     if (!errors.isValid) {
  //   //       setState({errors: errors.errors});
  //   //     }
  //   //   }
  //   // };
  // };
  const togglePasswordVisiblity = () => {
    setPasswordVisibe(!passwordVisible);
    // setState((prevState) => {
    //   return {passwordVisible: !prevState.passwordVisible};
    // });
  };
  const toggleConfirmPasswordVisiblity = () => {
    setConfirmPasswordVisible(!confirmpasswordVisible);
    // setState((prevState) => {
    //   return {confirmpasswordVisible: !prevState.confirmpasswordVisible};
    // });
  };
  // const toggleOldPasswordVisiblity = () => {
  //   setState((prevState) => {
  //     return {oldpasswordVisible: !prevState.oldpasswordVisible};
  //   });
  // };
  const handleSubmit = async (e) => {
    // e.preventDefault();
    let data = {
      password: password,
      confirmpassword: confirmpassword,
    };
    const errors = ValidateResetPassInput(data);
    console.log("error===>", errors);
    if (!errors.isValid) {
      setErrors(errors.errors);
      setSubmitting(false);
      // setState({...state, errors: errors.errors, submitting: false});
    } else {
      let reset_type = "mobile";
      // if(props.match)
      const urlParams = new URLSearchParams(window.location.search);
      const myParam = urlParams.get("isEmail");
      // console.log("IS EMAIL", myParam);
      if (myParam) {
        reset_type = "email";
      }
      let reqObj = new FormData();
      reqObj.set("reset_password_token", props.resetToken);
      reqObj.set("password", data.password);
      reqObj.set("reset_with", reset_type);

      try {
        setSubmitting(true);
        const response = await ResetPasswordWithTokenApi(reqObj);

        if (response.data.status === 200) {
          successToast({
            content: verifyObject(
              response,
              "data.message",
              "Password reseted successfully."
            ),
          });
          navigate("/signin");
          setSubmitting(false);
        }
        setSubmitting(false);
      } catch (error) {
        const { message } = getErrorObject(error);
        setSubmitting(false);

        errorToast({ content: message });
      }
    }
  };

  // const {confirmpassword, password, submitting} = state;
  // console.log("ERRORS", state.errors);

  return (
    <Fragment>
      <div className={LoginCSS.login_wrapper}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <LoginHeader />
              <div className={LoginCSS.login_form_card}>
                <h2 className="font-24 weight-600 margin-bottom-30 text-center">
                  Reset Password
                </h2>
                <Form onSubmit={handleSubmit}>
                  <Form.Item>
                    {/* <label className="font-14 weight-400 text-light-black push-10-b line-1-43">
                      Set New Password
                    </label> */}
                    <div className="relative">
                      <FloatLabel label="Set New Password" value={password} name="password" id="set_pwd">
                        <input
                          className="font-14 weight-400 form-control"
                          type={passwordVisible ? "text" : "password"}
                          name="password"
                          //placeholder="Set New Password"
                          label="Password"
                          onChange={(e) => setPassword(e.target.value)}
                          value={password}
                          id="set_pwd"
                        />
                        <img
                          src={passwordVisible ? imgEyeOpen : imgEyeClosed}
                          alt=""
                          className={LoginCSS.password_show}
                          onClick={togglePasswordVisiblity}
                        />
                      </FloatLabel>
                      {errors && (
                        <span className="validate-danger">{errors.password}</span>
                      )}
                    </div>
                  </Form.Item>

                  <Form.Item>
                    {/* <label className="font-14 weight-400 text-light-black push-10-b line-1-43">
                      Re-enter Password
                    </label> */}
                    <div className="relative">
                      <FloatLabel label="Re-enter Password" value={confirmpassword} name="confirmpassword" id="cnfrm_pwd">
                        <input
                          className="font-14 weight-400 form-control"
                          type={confirmpasswordVisible ? "text" : "password"}
                          name="confirmpassword"
                          //placeholder="Re-enter Password"
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          label="Password"
                          value={confirmpassword}
                          id="cnfrm_pwd"
                        />
                        <img
                          src={confirmpasswordVisible ? imgEyeOpen : imgEyeClosed}
                          alt=""
                          className={LoginCSS.password_show}
                          onClick={toggleConfirmPasswordVisiblity}
                        />
                      </FloatLabel>
                      {errors && (
                        <span className="validate-danger">
                          {errors.confirmpassword}
                        </span>
                      )}
                    </div>
                  </Form.Item>
                  <Form.Item className="text-center">
                    <Button
                      type="submit"
                      className="btn btn-primary large-btn margin-top-10"
                      disabled={submitting}
                      onClick={handleSubmit}
                    >
                      Reset Password &nbsp;
                      {submitting && <i className="fa fa-spinner fa-spin" />}
                    </Button>
                  </Form.Item>
                </Form>
              </div>

              <LoginFooter />

            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ResetPasswordWithToken;
